import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, formatErr, saveToken, clearToken } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  const check = useCallback(async () => {
    // On public routes (/com/, /login, /assinar, /verificar), do NOT call /auth/me at all.
    // The landing/sign pages don't need to know if the user is logged in,
    // and silencing this call prevents the React dev error overlay from showing
    // axios "Request failed with status code 401" noise.
    const path = typeof window !== "undefined" ? window.location.pathname : "/";
    const isPublic = path.startsWith("/login") || path.startsWith("/assinar") || path.startsWith("/verificar") || path.startsWith("/com/")
      || path === "/cliente" || path.startsWith("/cliente/"); // Portal da Cliente tem sessao propria (papi)
    if (isPublic) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      if (data?.access_token) saveToken(data.access_token);
      setUser(data);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatErr(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    clearToken();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, refresh: check }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
